import * as types from './types';

const styles = {
  general: {
    selector: '*',
    rules: {
      fontFamily: 'Lato,sans-serif',
    },
  },
  title: {
    selector: '.kbx-title',
    rules: {
      color: '#49B3F2',
    },
  },
  description: {
    selector: '.kbx-description',
    rules: {
      color: '#a3a3a3',
    },
  },
  option: {
    selector: '.kbx-radio, .kbx-checkbox',
    rules: {
      color: '#777777',
    },
  },
  button: {
    selector: '.kbx-btn',
    rules: {
      backgroundColor: '#44b3f2',
      color: '#fff',
      borderRadius: '5px',
      width: '250px',
      height: '50px',
      fontSize: '18px',
    },
  },
};

export const state = {
  id: null,
  styles,
};

export const mutations = {
  [types.QUIZ_SET_ID](state, id) {
    state.id = id;
  },
  [types.QUIZ_SET_STYLES](state, quizStyles) {
    state.styles = Object.assign({}, state.styles, quizStyles);
  },
  [types.QUIZ_UPDATE_STYLE](state, { item, rule, value }) {
    if (!state.styles[item]) {
      state.styles[item] = { rules: {} };
    }
    state.styles[item].rules[rule] = value;
  },
  [types.QUIZ_RESET_STATE](state) {
    state.id = null;
    state.styles = styles;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/quiz/mutations.js
 **/